export enum AreaTypes {
  Development_Area = 1,
  Completion_Area = 2,
  // DEPRECATED Drilling_Area = 3,
  // DEPRECATED Facility_Team_Area = 4,
  Horizontal_Operations_Area = 5,
  Lease_Area = 6,
  PWM_Area = 7,
  WaterDisposalSystem_Area = 8,
  Tank_Battery_Coverage_Area = 9,
  Type_Curve_Area = 10,
  TargetFormation_Area = 11,
  WaterNetwork_Area = 12,
  Tract_Area = 13,
  WaterSuperNetwork_Area = 15,
  WaterSubsystem_Area = 16,
  State_Area = 17,
  County_Area = 18,
  Zip_Code_Area = 19,
  Drilling_Area = 20,
  PIG_Area = 21
}